import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import {listAllCurrency} from "../../lib/Currency.js";

export {init}
Html.registerWidget('widget/specific/select-currency',{init:init})

function init(select){
  
  var
    selectedValue = select.attr("data-fw-select-value"),
    options;
    
  options = listAllCurrency(i18n.getShortLanguage()).map(currency=>'<option value="'+currency.code+'">'+currency.name+'</option>').join('')
  
  select
    .html(options)
    .find( "option[value='"+selectedValue+"']")
    .prop('selected',true);
  
}